


const MailShowContent = ({ children, emailSubject, emailSender, emailContentObject }) => {
   return (
      <div className="email-container gx-p-3">
         <h2 className="email-subject">{emailSubject}</h2>
         <div className="email-header">{emailSender}</div>
         <div className="email-content gx-mt-4">
            {emailContentObject?.type === "textHtml" ? (
               <div
                  className="email-html-content gx-pb-5"
                  dangerouslySetInnerHTML={{ __html: emailContentObject.content }}
               ></div>
            ) : (
               <div className="email-plain-content gx-pb-5">{emailContentObject.content}</div>
            )}
         </div>
         {children}
      </div>
   );
};

export default MailShowContent;
